import { render, staticRenderFns } from "./grade-bar.vue?vue&type=template&id=96a2719a&scoped=true"
import script from "./grade-bar.vue?vue&type=script&lang=js"
export * from "./grade-bar.vue?vue&type=script&lang=js"
import style0 from "./grade-bar.vue?vue&type=style&index=0&id=96a2719a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a2719a",
  null
  
)

export default component.exports